import { useEffect, useRef, useState, useCallback } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';

const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
const WARNING_BEFORE_MS = 60 * 1000; // show warning 1 minute before signout

export const useInactivityTimeout = () => {
    const { authStatus, signOut } = useAuthenticator((context) => [
        context.authStatus,
    ]);
    const [showWarning, setShowWarning] = useState(false);
    const warningTimerRef = useRef(null);
    const signoutTimerRef = useRef(null);
    const showWarningRef = useRef(false);

    const clearTimers = () => {
        clearTimeout(warningTimerRef.current);
        clearTimeout(signoutTimerRef.current);
    };

    const resetTimer = useCallback(() => {
        clearTimers();
        showWarningRef.current = false;
        setShowWarning(false);

        warningTimerRef.current = setTimeout(() => {
            showWarningRef.current = true;
            setShowWarning(true);
        }, TIMEOUT_MS - WARNING_BEFORE_MS);

        signoutTimerRef.current = setTimeout(() => {
            sessionStorage.clear();
            signOut();
        }, TIMEOUT_MS);
    }, [signOut]);

    useEffect(() => {
        if (authStatus !== 'authenticated') {
            clearTimers();
            setShowWarning(false);
            return;
        }

        const events = [
            'mousemove',
            'mousedown',
            'keypress',
            'scroll',
            'touchstart',
            'click',
        ];

        const handleActivity = () => {
            if (!showWarningRef.current) resetTimer();
        };

        events.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );
        resetTimer();

        return () => {
            events.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
            clearTimers();
        };
    }, [authStatus, resetTimer]);

    return { showWarning, resetTimer };
};
